import {Navigate, useRoutes} from "react-router-dom";
import DashboardLayout from "../layouts/dashboard";
import {getPathAfterLogin} from "../config";
import {getSessionOperator} from "../helper/session";
import {isPrimaryUser} from "../auth/FirebaseContext";
import {
    ActionsEditPage,
    ActionsList,
    ActionsListNew,
    ActionsReportPage,
    ActionsValueEditPage,
    ActionsValueListNew,
    AdditionalIncomePage,
    AdditionalRevenueDetailedReportPage,
    AllotmentEditPage,
   // AllotmentBoardPage,
    AllotmentList,
    AdminStatisticsPage,
    AllotmentNew,
    AllTicketsPage,
    AnalyticsAndCommissions,
    AttachedRateCardPage,
    BarriersNewPage,
    BarriersPage,
    BusEditPage,
    BusList,
    BusNew,
    DispatchDepots,
    DispatchDriverEdit,
    DispatchDriverNew,
    DispatchDrivers,
    DispatchScheduleDay,
    DispatchScheduleWeek,
    DispatchUnassigned,
    DispatchTurnusEdit,
    DispatchTurnusList,
    DispatchTurnusSchedule,
    DispatchDriverReport,
    DispatchTravelOrders,
    DispatchFleet,
    DispatchFleetHistory,
    CityLines,
    CityLineNew,
    CityLineEdit,
    CityZones,
    CityExceptions,
    CityDepartures,
    CityFares,
    CityPasses,
    CitySale,
    CityCards,
    CityInvoices,
    CityKmReport,
    CityTickets,
    CityTimetable,
    CityVehicleReport,
    CityDeviceReport,
    CityFinanceReport,
    CityInspectorReport,
    CityReports,
    CityValidations,
    CityRoutes,
    CityAccountPasses,
    CityDriverSettlement,
    CityRoutePlan,
    DispatchTurnusNew,
    BusTickets,
    CalculationOfIncomeForStationPage,
    CarrierReport,
    CarrierReportDetailed,
    CarrierReportEdit,
    CarrierReportPrivilegesTickets,
    CarrierReportDiscountedTickets,
    CarrierReportReturnTickets,
    CarrierReportTickets,
    CarriersEditPage,
    CarriersList,
    CarriersNew,
    CommentsEditPage,
    CommentsList,
    CommentsNew,
    CommissionCalculation,
    CurrentAllotmentListPreviewPage,
    CustomersEditPage,
    CustomersList,
    CustomersNew,
    BulkOperationalIntervalPage,
    DeparturesExceptionsPage,
    DeparturesLinkedListPage,
    DeparturesList,
    DeparturesListEditPage,
    DeparturesListNew,
    DeparturesStatus,
    DisabledLineStationsList,
    DisabledLineStationNew,
    DisabilitiesList,
    DisabilityEditPage,
    DisabilityNew,
    DiscountsEditPage,
    DiscountsList,
    DiscountsNew,
    HolidaysEditPage,
    HolidaysList,
    HolidaysNew,
    HomePage,
    InstantPage,
    InsuranceEditPage,
    InsuranceList,
    InsuranceNew,
    InternationalReportPage,
    WhiteListReportPage,
    InvoicePage,
    ItemsEditPage,
    ItemsNewPage,
    ItemsPage,
    RateCardItemsPage,
    LinesList,
    LinesListEditPage,
    LinesListNew,
    LinkedEditPage,
    LinkedNewPage,
    LinkPriceListTripPage,
    LiquidationPage,
    LocationsList,
    LocationsListEditPage,
    LocationsListNew,
    Login,
    MonthlyTicketsList,
    MonthlyTicketsListEditPage,
    MonthlyTicketsListNew,
    MultiPassesByClientPage,
    MultiPassValidationReportPage,
    NotificationsPage,
    OperatorsEditPage,
    OperatorsList,
    OperatorsNew,
    OtherOtpravnikPage,
    OtpravnikEditPage,
    OtpravnikList,
    OtpravnikNew,
    OtpravnikNewBIS,
    OverviewTicketAndOtherPage,
    ParkingList,
    ParkingServicesList,
    ParkingServicesNew,
    ParkingServicesEditPage,
    PeronizationList,
    PeronizationNew,
    PeronizationPrice,
    PeronizationStatus,
    PlatformBusynessPage,
    PlatformsEditPage,
    PlatformsList,
    PlatformsNew,
    PreviewCancelledTripsHistory,
    PreviewRatesHistory,
    PreviewTripExceptionHistory,
    PreviewTimes,
    PriceList,
    PriceListEditPage,
    PriceListNew,
    PriceListStationEditPage,
    PriceListStationNew,
    PriceStationsList,
    PrivilegesEditPage,
    PrivilegesList,
    PrivilegesNew, ProjectBugNew,
    ProjectImprovementsPage,
    PromoNotificationsList,
    ProjectRequestsPage,
    ProjectUpdateDetail,
    ProjectUpdatesPage,
    PublisherPage,
    ReportsPage,
    ScheduledDepAndArrList,
    SettingsPage,
    SoldServicesPage,
    SoldServicesReport,
    StationList,
    StationListEditPage,
    StationListNew,
    StationLineAssignmentPage,
    StationServicesPage,
    FidkpReportPage,
    TicketOperatorStatsPage,
    TicketSalesFinancialReportPage,
    TimesList,
    TrafficLogActionLogPage,
    TrafficLogsPage,
    TripAvailabilityCheckPage,
    TripSeatStatus,
    UnusedCameraEvents,
    UserPathPrivilegesPage,
    ValidatedTicketReportPage,
    ValidatedTicketsPage
} from "./elements";
import AuthGuard from "../auth/AuthGuard";
import {PATH_AUTH, PATH_DASHBOARD} from "./path";
import GuestGuard from "../auth/GuestGuard";
import ActionsValue from "../pages/Actions/ActionsValue";
import CommentsPage from "../pages/Comments";

function HomeRedirect() {
    return <Navigate to={getPathAfterLogin(getSessionOperator(), isPrimaryUser())} replace/>;
}

export default function Router() {
    return useRoutes([
        {
            path: "auth",
            children: [
                {
                    path: PATH_AUTH.login,
                    element: (
                        <GuestGuard>
                            <Login/>
                        </GuestGuard>
                    )
                }
            ]
        },
        {
            path: "",
            element: (
                <AuthGuard>
                    <DashboardLayout/>
                </AuthGuard>
            ),
            children: [
                {element: <HomeRedirect/>, index: true},
                {path: PATH_DASHBOARD.general.app, element: <HomePage/>},
                {path: PATH_DASHBOARD.admin.routes, element: <UserPathPrivilegesPage/>},
                {path: PATH_DASHBOARD.admin.availabilityCheck, element: <TripAvailabilityCheckPage/>},
                {path: PATH_DASHBOARD.admin.statistics, element: <AdminStatisticsPage/>},
                {path: PATH_DASHBOARD.general.stationServices, element: <StationServicesPage/>},
                {
                    path: PATH_DASHBOARD.reports.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.reports.overview} replace/>, index: true},
                        {path: PATH_DASHBOARD.reports.overview, element: <ReportsPage/>},
                        {path: PATH_DASHBOARD.reports.overviewTicketAndOther, element: <OverviewTicketAndOtherPage/>},
                        {path: PATH_DASHBOARD.reports.validatedTicketReport, element: <ValidatedTicketReportPage/>},
                        {path: PATH_DASHBOARD.reports.actionsReport, element: <ActionsReportPage/>},
                        {path: PATH_DASHBOARD.reports.liquidation, element: <LiquidationPage/>},
                        {path: PATH_DASHBOARD.reports.multiPassValidations, element: <MultiPassValidationReportPage/>},
                        {path: PATH_DASHBOARD.reports.multiPassesByClient, element: <MultiPassesByClientPage/>},
                        {path: PATH_DASHBOARD.reports.internationalReport, element: <InternationalReportPage/>},
                    ]
                },
                {path: PATH_DASHBOARD.general.invoices, element: <InvoicePage/>},
                {path: PATH_DASHBOARD.general.busTickets, element: <BusTickets/>},
                {path: PATH_DASHBOARD.general.soldServices, element: <SoldServicesPage/>},
                {path: PATH_DASHBOARD.general.settings, element: <SettingsPage/>},
                {path: PATH_DASHBOARD.general.notifications, element: <NotificationsPage/>},
                {path: PATH_DASHBOARD.preview.priceList, element: <PriceList isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.linesList, element: <LinesList isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.departuresList, element: <DeparturesList isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.timesList, element: <PreviewTimes isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.discountsList, element: <DiscountsList isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.driveParkList, element: <BusList isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.commentsList, element: <CommentsPage isPreview={true}/>},
                {
                    path: PATH_DASHBOARD.preview.departuresLinkedList,
                    element: <DeparturesLinkedListPage isPreview={true}/>
                },
                {path: PATH_DASHBOARD.preview.allotments, element: <AllotmentList isPreview={true}/>},
                {path: PATH_DASHBOARD.preview.peronizationStatus, element: <PeronizationStatus isPreview={true}/>},
                {
                    path: PATH_DASHBOARD.preview.currentAllotments,
                    element: <CurrentAllotmentListPreviewPage isPreview={true}/>
                },
                // {
                //     path: PATH_DASHBOARD.preview.previewDeparturesLinked,
                //     element: <PreviewDeparturesLinked isPreview={true}/>
                // },
                {
                    path: PATH_DASHBOARD.preview.cancelledTripsHistory,
                    element: <PreviewCancelledTripsHistory isPreview={true}/>
                },
                {path: PATH_DASHBOARD.preview.ratesHistory, element: <PreviewRatesHistory isPreview={true}/>},
                {
                    path: PATH_DASHBOARD.preview.tripExceptionHistory,
                    element: <PreviewTripExceptionHistory isPreview={true}/>
                },
                {
                    path: PATH_DASHBOARD.discounts.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.discounts.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.discounts.list, element: <DiscountsList/>},
                        {path: PATH_DASHBOARD.discounts.new, element: <DiscountsNew/>},
                        {path: ":name/edit", element: <DiscountsEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.privileges.root,
                    children: [
                        {path: PATH_DASHBOARD.privileges.list, element: <PrivilegesList/>},
                        {path: PATH_DASHBOARD.privileges.new, element: <PrivilegesNew/>},
                        {path: ":name/edit", element: <PrivilegesEditPage/>},
                        {path: PATH_DASHBOARD.privileges.listDisabilities, element: <DisabilitiesList/>},
                        {path: PATH_DASHBOARD.privileges.newDisability, element: <DisabilityNew/>},
                        {path: ":name/editDisability", element: <DisabilityEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.dispatchCenter.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.dispatchCenter.drivers} replace/>, index: true},
                        {path: PATH_DASHBOARD.dispatchCenter.depots, element: <DispatchDepots/>},
                        {path: PATH_DASHBOARD.dispatchCenter.drivers, element: <DispatchDrivers/>},
                        {path: PATH_DASHBOARD.dispatchCenter.driverNew, element: <DispatchDriverNew/>},
                        {path: PATH_DASHBOARD.dispatchCenter.scheduleWeek, element: <DispatchScheduleWeek/>},
                        {path: PATH_DASHBOARD.dispatchCenter.scheduleDay, element: <DispatchScheduleDay/>},
                        {path: PATH_DASHBOARD.dispatchCenter.unassigned, element: <DispatchUnassigned/>},
                        {path: PATH_DASHBOARD.dispatchCenter.turnus, element: <DispatchTurnusList/>},
                        {path: PATH_DASHBOARD.dispatchCenter.turnusSchedule, element: <DispatchTurnusSchedule/>},
                        {path: PATH_DASHBOARD.dispatchCenter.driverReport, element: <DispatchDriverReport/>},
                        {path: PATH_DASHBOARD.dispatchCenter.travelOrders, element: <DispatchTravelOrders/>},
                        {path: PATH_DASHBOARD.dispatchCenter.fleet, element: <DispatchFleet/>},
                        {path: "fleet/:vehicleId/history", element: <DispatchFleetHistory/>},
                        {path: PATH_DASHBOARD.dispatchCenter.turnusNew, element: <DispatchTurnusNew/>},
                        {path: "turnus/:id/edit", element: <DispatchTurnusEdit/>},
                        {path: "drivers/:id/edit", element: <DispatchDriverEdit/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.cityTransport.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.cityTransport.lines} replace/>, index: true},
                        {path: PATH_DASHBOARD.cityTransport.lines, element: <CityLines/>},
                        {path: PATH_DASHBOARD.cityTransport.lineNew, element: <CityLineNew/>},
                        {path: PATH_DASHBOARD.cityTransport.exceptions, element: <CityExceptions/>},
                        {path: "lines/:id/edit", element: <CityLineEdit/>},
                        {path: "lines/:id/departures", element: <CityDepartures/>},
                        {path: "lines/:id/timetable", element: <CityTimetable/>},
                        {path: PATH_DASHBOARD.cityTransport.routes, element: <CityRoutes/>},
                        {path: "routes/:lineId/plan", element: <CityRoutePlan/>},
                        {path: PATH_DASHBOARD.cityTransport.fares, element: <CityFares/>},
                        {path: PATH_DASHBOARD.cityTransport.passes, element: <CityPasses/>},
                        {path: PATH_DASHBOARD.cityTransport.sale, element: <CitySale/>},
                        {path: PATH_DASHBOARD.cityTransport.cards, element: <CityCards/>},
                        {path: PATH_DASHBOARD.cityTransport.reports, element: <CityReports/>},
                        {path: PATH_DASHBOARD.cityTransport.kilometers, element: <CityKmReport/>},
                        {path: PATH_DASHBOARD.cityTransport.vehicleReport, element: <CityVehicleReport/>},
                        {path: PATH_DASHBOARD.cityTransport.deviceReport, element: <CityDeviceReport/>},
                        {path: PATH_DASHBOARD.cityTransport.financeReport, element: <CityFinanceReport/>},
                        {path: PATH_DASHBOARD.cityTransport.inspectorReport, element: <CityInspectorReport/>},
                        {path: PATH_DASHBOARD.cityTransport.tickets, element: <CityTickets/>},
                        {path: PATH_DASHBOARD.cityTransport.invoices, element: <CityInvoices/>},
                        {path: PATH_DASHBOARD.cityTransport.accountPasses, element: <CityAccountPasses/>},
                        {path: PATH_DASHBOARD.cityTransport.employeeSettlement, element: <CityDriverSettlement/>},
                        {
                            path: PATH_DASHBOARD.cityTransport.driverSettlement,
                            element: <Navigate to={PATH_DASHBOARD.cityTransport.employeeSettlement} replace/>
                        },
                        {path: PATH_DASHBOARD.cityTransport.validations, element: <CityValidations/>},
                        {path: PATH_DASHBOARD.cityTransport.zones, element: <CityZones/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.bus.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.bus.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.bus.list, element: <BusList/>},
                        {path: PATH_DASHBOARD.bus.new, element: <BusNew/>},
                        {path: ":name/edit", element: <BusEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.priceList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.priceList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.priceList.list, element: <PriceList/>},
                        {path: PATH_DASHBOARD.priceList.linkPriceTrip, element: <LinkPriceListTripPage/>},
                        {path: PATH_DASHBOARD.priceList.new, element: <PriceListNew/>},
                        {path: PATH_DASHBOARD.priceList.newStation, element: <PriceListStationNew/>},
                        {path: PATH_DASHBOARD.priceList.stationsList, element: <PriceStationsList/>},
                        {path: PATH_DASHBOARD.priceList.instantEdit, element: <InstantPage/>},
                        {path: ":name/edit", element: <PriceListEditPage/>},
                        {path: ":name/edit-station", element: <PriceListStationEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.items.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.items.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.items.list, element: <ItemsPage/>},
                        {path: PATH_DASHBOARD.items.new, element: <ItemsNewPage/>},
                        {path: PATH_DASHBOARD.items.rateCardItems, element: <RateCardItemsPage/>},
                        {path: ":name/edit", element: <ItemsEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.tripSeatStatus.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.tripSeatStatus.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.tripSeatStatus.list, element: <TripSeatStatus/>},
                        {path: ":name/edit", element: <TripSeatStatus/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.stationList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.priceList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.stationList.list, element: <StationList/>},
                        {path: PATH_DASHBOARD.stationList.new, element: <StationListNew/>},
                        {path: ":name/edit", element: <StationListEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.locationList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.locationList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.locationList.list, element: <LocationsList/>},
                        {path: PATH_DASHBOARD.locationList.new, element: <LocationsListNew/>},
                        {path: ":name/edit", element: <LocationsListEditPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.linesList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.linesList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.linesList.list, element: <LinesList/>},
                        {path: PATH_DASHBOARD.linesList.new, element: <LinesListNew/>},
                        {path: ":name/edit", element: <LinesListEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.disabledLineStations.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.disabledLineStations.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.disabledLineStations.list, element: <DisabledLineStationsList/>},
                        {path: PATH_DASHBOARD.disabledLineStations.new, element: <DisabledLineStationNew/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.departuresList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.departuresList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.departuresList.list, element: <DeparturesList/>},
                        {path: PATH_DASHBOARD.departuresList.bulkOperationalInterval, element: <BulkOperationalIntervalPage/>},
                        {path: PATH_DASHBOARD.departuresList.new, element: <DeparturesListNew/>},
                        {
                            path: PATH_DASHBOARD.departuresList.departuresLinkedList,
                            element: <DeparturesLinkedListPage/>
                        },
                        {path: PATH_DASHBOARD.departuresList.linked, element: <LinkedNewPage/>},
                        {
                            path: PATH_DASHBOARD.departuresList.departuresExceptions,
                            element: <DeparturesExceptionsPage/>
                        },
                        {path: ":name/editLinked", element: <LinkedEditPage/>},
                        {path: ":name/edit", element: <DeparturesListEditPage/>},
                        {
                            path: PATH_DASHBOARD.departuresList.departuresLinkedAttachRateCard,
                            element: <AttachedRateCardPage/>
                        },

                    ]
                },
                {
                    path: PATH_DASHBOARD.allotment.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.allotment.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.allotment.list, element: <AllotmentList/>},
                        {path: PATH_DASHBOARD.allotment.assigned, element: <AllotmentList assigned={true}/>},
                        {path: PATH_DASHBOARD.allotment.new, element: <AllotmentNew/>},
                        {path: PATH_DASHBOARD.allotment.assign, element: <AllotmentNew assigned={true}/>},
                        {path: ":name/edit", element: <AllotmentEditPage/>},
                        //{path: "board/:tripHasVehicleId", element: <AllotmentBoardPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.timesList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.timesList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.timesList.list, element: <TimesList/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.promoNotifications.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.promoNotifications.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.promoNotifications.list, element: <PromoNotificationsList/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.actions.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.actions.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.actions.list, element: <ActionsList/>},
                        {path: PATH_DASHBOARD.actions.new, element: <ActionsListNew/>},
                        {path: ":name/edit", element: <ActionsEditPage/>},
                        {path: PATH_DASHBOARD.actions.actionValueList, element: <ActionsValue/>},
                        {path: PATH_DASHBOARD.actions.actionValueNew, element: <ActionsValueListNew/>},
                        {path: ":name/actionValueListEdit", element: <ActionsValueEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.monthlyTicketsList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.monthlyTicketsList.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.monthlyTicketsList.list, element: <MonthlyTicketsList/>},
                        {path: PATH_DASHBOARD.monthlyTicketsList.new, element: <MonthlyTicketsListNew/>},
                        {path: ":name/edit", element: <MonthlyTicketsListEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.customers.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.customers.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.customers.list, element: <CustomersList/>},
                        {path: PATH_DASHBOARD.customers.new, element: <CustomersNew/>},
                        {path: ":name/edit", element: <CustomersEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.carriers.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.carriers.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.carriers.list, element: <CarriersList/>},
                        {path: PATH_DASHBOARD.carriers.new, element: <CarriersNew/>},
                        {path: ":name/edit", element: <CarriersEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.otpravnik.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.otpravnik.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.otpravnik.list, element: <OtpravnikList/>},
                        {path: PATH_DASHBOARD.otpravnik.other, element: <OtherOtpravnikPage/>},
                        {path: PATH_DASHBOARD.otpravnik.new, element: <OtpravnikNew/>},
                        {path: ":name/edit", element: <OtpravnikEditPage/>},
                        {path: PATH_DASHBOARD.otpravnik.unusedCameraEvents, element: <UnusedCameraEvents/>},
                        {path: PATH_DASHBOARD.otpravnik.trafficLogs, element: <TrafficLogsPage/>},
                        {path: PATH_DASHBOARD.otpravnik.actionLog, element: <TrafficLogActionLogPage/>},
                        {path: PATH_DASHBOARD.otpravnik.publisher, element: <PublisherPage/>},
                        {path: PATH_DASHBOARD.otpravnik.newBIS, element: <OtpravnikNewBIS/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.holidays.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.holidays.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.holidays.list, element: <HolidaysList/>},
                        {path: PATH_DASHBOARD.holidays.new, element: <HolidaysNew/>},
                        {path: ":name/edit", element: <HolidaysEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.scheduledDepAndArr.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.scheduledDepAndArr.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.scheduledDepAndArr.list, element: <ScheduledDepAndArrList/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.peronization.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.peronization.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.peronization.list, element: <PeronizationList/>},
                        {path: PATH_DASHBOARD.peronization.price, element: <PeronizationPrice/>},
                        {path: PATH_DASHBOARD.peronization.new, element: <PeronizationNew/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.parking.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.parking.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.parking.list, element: <ParkingList/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.parkingServices.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.parkingServices.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.parkingServices.list, element: <ParkingServicesList/>},
                        {path: PATH_DASHBOARD.parkingServices.new, element: <ParkingServicesNew/>},
                        {path: ":id/edit", element: <ParkingServicesEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.carrierReport.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.carrierReport.sumarized} replace/>, index: true},
                        {path: PATH_DASHBOARD.carrierReport.sumarized, element: <CarrierReport/>},
                        {path: PATH_DASHBOARD.carrierReport.edit, element: <CarrierReportEdit/>},
                        {path: PATH_DASHBOARD.carrierReport.detailed, element: <CarrierReportDetailed/>},
                        {
                            path: PATH_DASHBOARD.carrierReport.privilegesTickets,
                            element: <CarrierReportPrivilegesTickets/>
                        },
                        {
                            path: PATH_DASHBOARD.carrierReport.discountedTickets,
                            element: <CarrierReportDiscountedTickets/>
                        },
                        {path: PATH_DASHBOARD.carrierReport.returnTickets, element: <CarrierReportReturnTickets/>},
                        {path: PATH_DASHBOARD.carrierReport.tickets, element: <CarrierReportTickets/>},
                        {path: PATH_DASHBOARD.carrierReport.validatedTickets, element: <ValidatedTicketsPage/>},
                        {path: PATH_DASHBOARD.carrierReport.ticketOperatorStats, element: <TicketOperatorStatsPage/>},
                        {
                            path: PATH_DASHBOARD.carrierReport.ticketSalesFinancialReport,
                            element: <TicketSalesFinancialReportPage/>
                        },
                        {path: PATH_DASHBOARD.carrierReport.whiteList, element: <WhiteListReportPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.otherSalesChannels.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.otherSalesChannels.fidkp} replace/>, index: true},
                        {path: PATH_DASHBOARD.otherSalesChannels.fidkp, element: <FidkpReportPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.commissionCalculation.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.commissionCalculation.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.commissionCalculation.list, element: <CommissionCalculation/>},
                        {path: PATH_DASHBOARD.commissionCalculation.allTickets, element: <AllTicketsPage/>},

                        {
                            path: PATH_DASHBOARD.commissionCalculation.incomeForStation,
                            element: <CalculationOfIncomeForStationPage/>
                        },
                        {path: PATH_DASHBOARD.commissionCalculation.additionalIncome, element: <AdditionalIncomePage/>},
                        {
                            path: PATH_DASHBOARD.commissionCalculation.analyticsAndCommissions,
                            element: <AnalyticsAndCommissions/>
                        },
                        {
                            path: PATH_DASHBOARD.commissionCalculation.additionalRevenueDetailedReport,
                            element: <AdditionalRevenueDetailedReportPage/>
                        }
                    ]
                },
                {
                    path: PATH_DASHBOARD.insurance.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.insurance.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.insurance.list, element: <InsuranceList/>},
                        {path: PATH_DASHBOARD.insurance.new, element: <InsuranceNew/>},
                        {path: ":name/edit", element: <InsuranceEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.platforms.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.platforms.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.platforms.list, element: <PlatformsList/>},
                        {path: PATH_DASHBOARD.platforms.new, element: <PlatformsNew/>},
                        {path: PATH_DASHBOARD.platforms.busyness, element: <PlatformBusynessPage/>},
                        {path: '/platforms/busyness/:id', element: <PlatformBusynessPage/>},
                        {path: ":id/edit", element: <PlatformsEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.operators.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.operators.list}/>, index: true},
                        {path: PATH_DASHBOARD.operators.list, element: <OperatorsList/>},
                        {path: PATH_DASHBOARD.operators.new, element: <OperatorsNew/>},
                        {path: ":name/edit", element: <OperatorsEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.comments.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.comments.list}/>, index: true},
                        {path: PATH_DASHBOARD.comments.list, element: <CommentsList/>},
                        {path: PATH_DASHBOARD.comments.new, element: <CommentsNew/>},
                        {path: ":name/edit", element: <CommentsEditPage/>}
                    ]
                },
                {
                    path: PATH_DASHBOARD.departuresStatusList.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.departuresStatusList.list}/>, index: true},
                        {path: PATH_DASHBOARD.departuresStatusList.list, element: <DeparturesStatus/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.barriers.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.barriers.list}/>, index: true},
                        {path: PATH_DASHBOARD.barriers.list, element: <BarriersPage/>},
                        {path: PATH_DASHBOARD.barriers.terminals, element: <BarriersPage/>},
                        {path: PATH_DASHBOARD.barriers.partners, element: <BarriersPage/>},
                        {path: PATH_DASHBOARD.barriers.reports, element: <BarriersPage/>},
                        {path: PATH_DASHBOARD.barriers.new, element: <BarriersNewPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.projectImprovements.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.projectImprovements.updates}/>, index: true},
                        {path: PATH_DASHBOARD.projectImprovements.updates, element: <ProjectUpdatesPage/>},
                        {path: PATH_DASHBOARD.projectImprovements.requests, element: <ProjectRequestsPage/>},
                        {path: PATH_DASHBOARD.projectImprovements.bugs, element: <ProjectImprovementsPage/>},
                        {path: PATH_DASHBOARD.projectImprovements.details, element: <ProjectUpdateDetail/>},
                        { path: PATH_DASHBOARD.projectImprovements.newBug, element: <ProjectBugNew /> }
                    ]
                },
                {
                    path: PATH_DASHBOARD.stationLineAssignment.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.stationLineAssignment.list} replace/>, index: true},
                        {path: PATH_DASHBOARD.stationLineAssignment.list, element: <StationLineAssignmentPage/>},
                    ]
                },
                {
                    path: PATH_DASHBOARD.servicesReport.root,
                    children: [
                        {element: <Navigate to={PATH_DASHBOARD.servicesReport.list}/>, index: true},
                        {path: PATH_DASHBOARD.servicesReport.list, element: <SoldServicesReport/>},
                    ]
                },
                // {
                //     path: PATH_DASHBOARD.items.root,
                //     children: [
                //         {element: <Navigate to={ PATH_DASHBOARD.priceList.stationsServicesList} replace/>, index: true},
                //         {path:  PATH_DASHBOARD.priceList.stationsServicesList, element: <ServicesList/>},
                //         {path: PATH_DASHBOARD.items.new, element: <ServicesNew/>},
                //         {path: ":name/edit", element: <ServicesEditPage/>}
                //     ]
                // },
            ]
        },
    ]);
}


